/** The slice of Stream's send response a bounce is read from. */
export interface SentMessage {
  id?: string;
  type?: string;
  created_at?: string;
  moderation?: { action?: string };
  moderation_details?: { action?: string };
}

/** A chat's unacknowledged bounce: where its card goes, and what analytics names it. */
export interface Bounce {
  channelId: string;
  messageId: string;
  at: string;
}

/** A send Stream moderation refused; the composer hands the text back to be rewritten. */
export class MessageBouncedError extends Error {
  constructor() {
    super('message bounced by moderation');
    this.name = 'MessageBouncedError';
  }
}

/** stream-chat's own `isBouncedMessage`, which the package does not export. */
export function isBounced(message: SentMessage | undefined): boolean {
  return (
    message?.type === 'error' &&
    (message.moderation_details?.action === 'MESSAGE_RESPONSE_ACTION_BOUNCE' ||
      message.moderation?.action === 'bounce')
  );
}

export function toBounce(sent: SentMessage, channelId: string): Bounce {
  return {
    channelId,
    messageId: sent.id ?? crypto.randomUUID(),
    at: (sent.created_at ? new Date(sent.created_at) : new Date()).toISOString(),
  };
}
